// Move gallery modal to body on page load
document.addEventListener('DOMContentLoaded', function() {
  const galleryModal = document.getElementById('bsGalleryModal');
  if (galleryModal && galleryModal.parentElement !== document.body) {
    document.body.appendChild(galleryModal);
  }

  // Add click handlers to all gallery images
  const galleryImages = document.querySelectorAll('[data-open-bs-gallery]');
  galleryImages.forEach(image => {
    image.addEventListener('click', function(e) {
      e.preventDefault();
      const imageIndex = this.dataset.imageIndex;
      openGalleryModal(imageIndex);
    });
  });
});

function openGalleryModal(imageIndex) {
  const modal = document.getElementById('bsGalleryModal');
  if (!modal) {
    return;
  }

  // Save scroll position BEFORE any DOM changes
  const scrollY = window.scrollY;
  modal.dataset.scrollPosition = scrollY;

  // Hide all images first
  const allImages = modal.querySelectorAll('[data-modal-image]');
  allImages.forEach(img => {
    img.classList.add('m:hidden');
    img.style.display = 'none';
  });

  // Show only the selected image
  const selectedImage = modal.querySelector(`[data-modal-image="${imageIndex}"]`);
  if (selectedImage) {
    selectedImage.classList.remove('m:hidden');
    selectedImage.style.display = 'flex';
  }

  // Show the modal and lock scroll (without position fixed to avoid scroll jump)
  modal.classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeGalleryModal() {
  const modal = document.getElementById('bsGalleryModal');
  if (!modal) return;

  modal.classList.remove('active');
  document.body.style.overflow = '';
}

function closeGalleryModalOnOverlay(event) {
  if (event.target.id === 'bsGalleryModal') {
    closeGalleryModal();
  }
}

// Close modal on Escape key
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    closeGalleryModal();
  }
});
